import { Component, OnInit, Inject,ViewChild,OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import * as XLSX from 'sheetjs-style';
type AOA = any[][];
import {ODSService} from 'app/main/pagina/tools/gestUsu/services/ods.service';
import Swal from 'sweetalert2';
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
@Component({
  selector: 'app-result-emprising',
  templateUrl: './result-emprising.component.html',
  styleUrls: ['./result-emprising.component.scss']
})
export class ResultEmprisingComponent implements OnInit {
  data: AOA = [];
  files: any = [];
  tiposPestañasExcel:any[]=[
    { clave: 1, nombre: 'WARNING', claveSeccion: 'WARNING', visible: true },
    { clave: 2, nombre: 'Truncated Comments', claveSeccion: 'Truncated Comments', visible: true },
    { clave: 3, nombre: 'Client Info', claveSeccion: 'Client Info', visible: true },
    { clave: 4, nombre: 'Statements', claveSeccion: 'Statements', visible: true },
    { clave: 5, nombre: 'Organization', claveSeccion: 'Organization', visible: true },
    { clave: 6, nombre: 'Demographics', claveSeccion: 'Demographics', visible: true },
    { clave: 7, nombre: 'Comments', claveSeccion: 'Comments', visible: true },
    { clave: 8, nombre: 'FocusAreas', claveSeccion: 'FocusAreas', visible: true },
  ];
fileFlagChange:boolean;
  constructor(
  @Inject(MAT_DIALOG_DATA) public datos: any,
  private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  private translateSrv: TranslateService,
  private _odsService: ODSService,
  ) {
    lang_resultados.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit(){
        console.log('datos',this.datos);
        this.fileFlagChange=this.datos.fileFlags[0].uploaded;
  }

  cargaExcelTemplate(evt: any){
    this.modalGuardado();
    let hojasExcel:any[]=[];
let datosFinal={
  productoId:this.datos.productoId,
  hojas:[],
  type:1,
};
    console.log("entro este vines de cargar excel");
    setTimeout(()=>{                           //<<<---using ()=> syntax
    }, 3000);

    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
      console.log("hojas:",wb.SheetNames);
      console.log("hojas:",wb);


  wb.SheetNames.forEach(nombreHoja => {
    const ws: XLSX.WorkSheet = wb.Sheets[nombreHoja];
    const datosHojas = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
    console.log('datosHojas',datosHojas);
    nombreHoja=nombreHoja.replace(" ","_");
    console.log('nombreHoja',nombreHoja);

    if (datosHojas.length>0) {
      datosHojas[0].forEach((nombreColumna,i) => {
        datosHojas[0][i]=nombreColumna.toString().replace(" ","_");
      });

    }
     let datosHoja={
       name:nombreHoja,
       columns:datosHojas[0],
       records:[],
     }
     for (let index = 1; index < datosHojas.length; index++) {
       let datosFila:any={};
       datosHojas[index].forEach((celda,i) => {
      datosFila[datosHojas[0][i]]=celda;
       });

       datosHoja.records.push(datosFila);
     }


datosFinal.hojas.push(datosHoja);

  });
  console.log('datosFinal',datosFinal);
this.uploadRawDataFileEmprising(datosFinal);

    };


    reader.readAsBinaryString(target.files[0]);
    evt.target.value = '';
    console.log('datosFinal',datosFinal);

  }


uploadRawDataFileEmprising(data){
  this._odsService.uploadRawDataFile(this.datos.empresaId,data).subscribe(response => {
    console.log('response',response);
    this.fileFlagChange=true;
    Swal.close();
  }, error => {
    console.log("error", error);
  });

}
modalGuardado(){
  let mensaje="Importando información row data";
    this.translateSrv.get('CONFING_RESUL_EMP.UPLO_INF').subscribe((res: string) => { mensaje = res; });
    // this.translateSrv.get('CONFING_RESUL_EMP.SUCC_UPLO_INF').subscribe((res: string) => { mensaje = res; });

  Swal.fire({
    title: mensaje,
    allowOutsideClick: false,
    showConfirmButton: false,
    imageUrl: localStorage.getItem('urlGifBroker'),
    imageWidth: 100,
    imageHeight: 60,
  });
}
}
